import { Link } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import { Separator } from "../components/ui/separator";
import { ArrowLeft, Quotes } from "@phosphor-icons/react";

const SBL_LOGO = "/sbl-logo.jpeg";

export const ALL_TESTIMONIALS = [
  { name: "Rachael Esanola", role: "Education Professional, Nigeria", quote: "This program came at a critical moment for me. Just when I was losing hope in the system, SBL reminded me that real change happens through systems and intentional leadership." },
  { name: "Oluwayemisi Ruth Lawal", role: "Meridian Heights International School", quote: "SBL completely shifted my perspective. I now understand that student experience, behaviour, and leadership are shaped by the system, not just individuals." },
  { name: "Ameh Arome Augustina", role: "Head of School, Davet International School", quote: "SBL was a truly transformative experience. It equipped me with practical skills in HR, finance, strategy, and operations. This is one of the best investments I've made in myself." },
  { name: "Nwokocha Happiness", role: "BrightPath Educational, Nigeria", quote: "SBL transformed me from just an educator into a school builder. I now understand that real school growth requires strategy, structure, culture, and financial awareness." },
  { name: "Adelokun Oluwafunmilayo", role: "Co-Founder, The Hoplites Kingdom Schools", quote: "This program redefined leadership for me. Effective schools are built on clear systems, structured processes, and intentional planning, not assumptions." },
  { name: "Paul A. Adetona", role: "Education Professional, Nigeria", quote: "SBL gave me a complete mindset shift, from academic leadership to non-instructional leadership. It exposed me to real-world school management concepts I had never encountered." },
  { name: "Chilipo Gunda", role: "Senior Education Professional, Malawi", quote: "SBL has been both transformative and practical. It strengthened my ability to lead with clarity, apply strategies effectively, and build a strong, high-performing school culture." },
  { name: "Emily Loko", role: "Education Professional, Kenya", quote: "My experience with the School Builder Lab Africa has been both empowering and practical. It helped me move beyond day-to-day activities to thinking in systems and long-term impact." },
  { name: "Eni Ngozi Sylvia", role: "School Leader, Alpha's Choice Montessori", quote: "SBL was a mind-shifting experience. It challenged my leadership approach, deepened my thinking, and reset my perspective on how schools should be led." },
  { name: "Sunday Chidimma Ehis", role: "School Proprietress, RivKids International", quote: "I came into this program running a school on instinct. SBL taught me to stop guessing and start building with intention, systems, and structure." },
  { name: "Ojeyinka Oladunni Shade", role: "School Admin, Nigeria", quote: "I joined with assumptions about school management. SBL corrected them all. I now approach every challenge with a strategic mindset, not an emotional one." },
  { name: "Eneh Grace Ogochukwu", role: "Education Professional, Nigeria", quote: "SBL opened my eyes to what it truly means to lead a school. The practical tools and frameworks are things I apply daily." },
  { name: "Munirat A. Makanjuola", role: "Education Professional, Nigeria", quote: "Before SBL, I was a teacher trying to be an administrator. Now I am a school builder who understands structure, systems, and leadership." },
  { name: "Shyllon Opeyemi Oluwakemi", role: "Education Professional, Nigeria", quote: "SBL didn't just teach me leadership, it taught me how to think like a builder. Every school needs systems, and now I know how to create them." },
  { name: "Odafe Okagbare Endurance", role: "School Administrator, Nigeria", quote: "The program helped me understand the business side of running a school. Finance, HR, compliance — SBL covered it all practically." },
  { name: "Oguntimehin Azeezat Omowonuola", role: "Education Professional, Nigeria", quote: "SBL gave me the framework I lacked. I now lead with clarity, purpose, and confidence. My school is better for it." },
  { name: "Bello Habibat", role: "School Leader, Nigeria", quote: "The knowledge from SBL is something I carry into every decision. It has shaped how I plan, how I lead, and how I build." },
];

// Landing page selection: includes international graduates (Malawi, Kenya)
export const LANDING_TESTIMONIALS = [
  ALL_TESTIMONIALS[0],  // Rachael Esanola - Nigeria
  ALL_TESTIMONIALS[6],  // Chilipo Gunda - Malawi
  ALL_TESTIMONIALS[2],  // Ameh Arome Augustina - Nigeria
  ALL_TESTIMONIALS[7],  // Emily Loko - Kenya
  ALL_TESTIMONIALS[4],  // Adelokun Oluwafunmilayo - Nigeria
  ALL_TESTIMONIALS[3],  // Nwokocha Happiness - Nigeria
];

const INITIALS_COLORS = [
  "bg-blue-800", "bg-slate-800", "bg-emerald-700", "bg-amber-700",
  "bg-indigo-700", "bg-rose-700", "bg-teal-700", "bg-violet-700", "bg-cyan-700",
  "bg-sky-700", "bg-orange-700", "bg-fuchsia-700", "bg-lime-700",
  "bg-stone-700", "bg-pink-700", "bg-blue-600", "bg-emerald-800",
];

function getInitials(name) {
  return name.split(" ").map(n => n[0]).join("").slice(0, 2).toUpperCase();
}

export default function TestimonialsPage() {
  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-xl border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src={SBL_LOGO} alt="SBL" className="w-9 h-9 object-contain rounded-sm" />
            <span className="text-base sm:text-lg font-bold tracking-tight text-slate-950" style={{ fontFamily: "'Outfit', sans-serif" }}>
              School Builder Lab Africa
            </span>
          </Link>
          <Link to="/" className="text-sm text-slate-600 hover:text-slate-900 flex items-center gap-1">
            <ArrowLeft size={14} /> Back to Home
          </Link>
        </div>
      </header>

      <div className="bg-slate-950 text-white py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-amber-400 mb-3">Testimonials</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
            What Our Graduates Say
          </h1>
          <p className="text-base text-white/70 mt-4 max-w-xl mx-auto">
            Cohort One graduates share their transformation stories from School Builder Lab Africa.
          </p>
        </div>
      </div>

      <section className="py-16 sm:py-20 md:py-24" data-testid="testimonials-full-page">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {ALL_TESTIMONIALS.map((t, i) => (
              <Card key={i} className="border border-slate-200 rounded-none shadow-sm hover:shadow-md transition-all" data-testid={`testimonial-card-${i}`}>
                <CardContent className="p-6">
                  <Quotes size={22} className="text-blue-800/20 mb-3" weight="fill" />
                  <p className="text-sm text-slate-700 leading-relaxed italic mb-5">"{t.quote}"</p>
                  <Separator className="mb-4" />
                  <div className="flex items-center gap-3">
                    <div className={`w-12 h-12 rounded-full flex-shrink-0 flex items-center justify-center text-white text-sm font-bold ${INITIALS_COLORS[i % INITIALS_COLORS.length]}`}>
                      {getInitials(t.name)}
                    </div>
                    <div className="min-w-0">
                      <p className="text-sm font-semibold text-slate-900 truncate">{t.name}</p>
                      <p className="text-xs text-slate-500 truncate">{t.role}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <footer className="bg-slate-950 text-slate-400 py-8 text-center text-xs">
        <p>&copy; {new Date().getFullYear()} School Builder Lab Africa. All rights reserved.</p>
      </footer>
    </div>
  );
}
